import currentWeekNumber from "current-week-number";
import { add, endOfWeek, format, startOfWeek } from "date-fns";

class DateService {

    static getSplitDate(str) {
        let [year, month, day] = str.match(/(\d+)-(\d+)-(\d+)/);
        return { year, month, day };
    }

    static getWeekDay(date) {
        return (date.getDay() + 6) % 7;
    }

    static getCurrentWeekNumber(date) {
        return currentWeekNumber(date);
    }

    static getCurrentDate() {
        return format(new Date(), "yyyy-MM-dd");
    }

    static getNextDay() {
        return add(new Date(), { days: 1 });
    }

    static convertDate(date) {
        return format(date, "yyyy-MM-dd");
    }

    static getNextWeek() {
        let today = new Date();
        return new Date(today.getFullYear(), today.getMonth(), today.getDate() + 7);
    }

    static getWeekStartDate(date) {
        return startOfWeek(date, { weekStartsOn: 1 });
    }

    static getWeekEndDate(date) {
        return endOfWeek(date, { weekStartsOn: 1 });
    }

    static checkIfDateIsInPast(date) {
        let today = new Date();
        return new Date(date) < new Date(today.toDateString());
    }

    static getDayName(dateString) {
        const [date, options] = [new Date(dateString), { weekday: "long" }];
        return new Intl.DateTimeFormat("en-Us", options).format(date);
    }
}

export default DateService;
